import MusicIcon from '@/CustomIcons/MusicIcon'
import MenuButton from '@/UIComponents2/MenuButton/MenuButton'
import { useTranslation } from 'react-i18next'
import AudioInputsMenu from '../shared/AudioInputsMenu'

type MusicDevicesMenuButtonProps = {
    labelPosition?: 'inside' | 'outside'
    triggerClassName?: string
}
const MusicDevicesMenuButton = (props: MusicDevicesMenuButtonProps) => {
    const { t } = useTranslation()

    return (
        <MenuButton
            label={t('Music Devices')}
            labelPosition={props.labelPosition}
            triggerClassName={props.triggerClassName}
            icon={<MusicIcon style={{ fontSize: '1.3rem' }} />}
            content={<AudioInputsMenu />}
        />
    )
}

export default MusicDevicesMenuButton
